import { ProductUrls } from "_core/types";

export const pagesList = [
  ProductUrls.Postcode,
  ProductUrls.OffStreetParking,
  ProductUrls.ChargerCustomisation,
  ProductUrls.PersonalDetails,
];
